export default "__VITE_ASSET__BPRoodaK__"